import type { RequestedAttachmentPayload } from '#/api/ats';
import type {
  ApiEmbedSearchWidgetId,
  ApiS3FileId,
} from '#/api/types/ApiTypedId';
import { postJson } from '#/utils/http/postJson';

type Args = {
  listingId: string;
  listingType: 'VOLOP' | 'JOB';
  searchWidgetId: ApiEmbedSearchWidgetId;
  firstName: string;
  lastName: string;
  resumeS3FileId: ApiS3FileId | null;
  email: string;
  requestedAttachments: (RequestedAttachmentPayload | null)[];
  requestedAttachmentsHash: string;
};

export function embedSearchWidgetApiCreateListingApplication({
  listingId,
  listingType,
  searchWidgetId,
  firstName,
  lastName,
  resumeS3FileId,
  email,
  requestedAttachments,
  requestedAttachmentsHash,
}: Args) {
  return postJson<void>(
    `/data/embed-search-widgets/${searchWidgetId}/listing-applications`,
    {
      id: listingId,
      type: listingType,
      firstName,
      lastName,
      resumeS3FileId,
      email,
      requestedAttachments,
      requestedAttachmentsHash,
    },
  );
}
